import { Palette } from '@core/config/constants';

/** Una opcion de color con su nombre visible. */
export interface ColorOption {
  readonly name: string;
  readonly value: number;
}

/** Una opcion de accesorio representada por un emoji (placeholder hasta tener arte). */
export interface AccessoryOption {
  readonly name: string;
  readonly emoji: string;
}

export const DRESS_COLORS: readonly ColorOption[] = [
  { name: 'Rosa', value: 0xff5fa2 },
  { name: 'Violeta', value: 0x7c4dff },
  { name: 'Celeste', value: 0x4dd0e1 },
  { name: 'Amarillo', value: 0xffd54f },
  { name: 'Verde', value: 0x2ecc71 },
  { name: 'Coral', value: 0xff7043 },
];

export const BACKGROUND_COLORS: readonly ColorOption[] = [
  { name: 'Noche', value: 0x1a1033 },
  { name: 'Escenario', value: 0x2d1b4e },
  { name: 'Atardecer', value: 0x5d2a6b },
  { name: 'Menta', value: 0x1e5a52 },
];

export const ACCESSORIES: readonly AccessoryOption[] = [
  { name: 'Sin accesorio', emoji: '' },
  { name: 'Moño', emoji: '🎀' },
  { name: 'Corona', emoji: '👑' },
  { name: 'Auriculares', emoji: '🎧' },
  { name: 'Anteojos', emoji: '🕶️' },
  { name: 'Flor', emoji: '🌸' },
  { name: 'Estrella', emoji: '⭐' },
];

/** Configuracion del minijuego de estilo. */
export const DressUpConfig = {
  key: 'DressUpScene',
  title: 'Estilo y Moda',
  description: 'Arma tu look para el escenario y guarda tu estilo.',
  icon: '👗',
  color: Palette.accent,

  /** Estrellas que se ganan al guardar un look. */
  coinsPerLook: 10,
} as const;
